import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { usePaymentList } from '@/features/student-management/hooks/usePaymentList';
import { usePersonDetail } from '@/features/student-management/hooks/usePersonDetail';
import { PaymentTable } from '@/features/student-management/ui/organisms/PaymentTable';
import { PaymentListTemplate } from '@/features/student-management/ui/templates/PaymentListTemplate';

export const Route = createFileRoute('/_authenticated/persons/$id/payments/')({
  component: PersonPaymentsPage,
});

function PersonPaymentsPage() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const personId = Number(id);
  const { person } = usePersonDetail(personId);
  const { data, isLoading } = usePaymentList(personId);

  return (
    <PaymentListTemplate
      filterPanel={
        <div className="flex items-center gap-xs p-none">
          <span className="ts-paragraph-xs !font-medium text-ctx-content-title">
            {person ? `${person.firstName} ${person.lastName}` : 'Aluno'}
          </span>
          <span className="ts-caption-xxs text-ctx-content-placeholder">
            {data.length} plano(s) encontrado(s)
          </span>
        </div>
      }
      table={
        <PaymentTable
          data={data}
          isLoading={isLoading}
          onEditPlan={planId =>
            void navigate({
              to: '/persons/payments/plans/$planId',
              params: { planId: String(planId) },
            })
          }
          onViewParcels={planId =>
            void navigate({
              to: '/persons/payments/plans/$planId/parcels',
              params: { planId: String(planId) },
            })
          }
          onCancelPlan={_planId => {}}
          onAddPlan={_pId => {}}
        />
      }
    />
  );
}
